import { ViewerCommand } from './ViewerCommand';
export class RemoveObjectCommand extends ViewerCommand {
    constructor(objects, viewer) {
        super(viewer, objects);
        this.parents = {};
        this.type = 'RemoveObjectCommand';
        this.name = this.composeName();
        objects.forEach((o) => {
            if (o.parent) {
                this.parents[o.uuid] = { parent: o.parent, index: o.parent.children.indexOf(o) };
            }
        });
    }
    execute() {
        this.viewer.removeObjects(...this.objects);
    }
    undo() {
        this.viewer.addObjects(this.objects, this.parents);
    }
    update(cmd) {
        throw new Error(`${this.type} can not be updated`);
    }
    toJSON() {
        const output = super.toJSON();
        output.parentIndices = {};
        Object.keys(this.parents).forEach((key) => {
            const parentInfo = this.parents[key];
            output.parentIndices[key] = {
                parentUUID: parentInfo.parent.uuid,
                index: parentInfo.index,
            };
        });
        return output;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.parents = {};
        Object.keys(json.parentIndices).forEach((objectUUID) => {
            const parentInfo = json.parentIndices[objectUUID];
            const parent = this.viewer.getObjectByUUID(parentInfo.parentUUID);
            if (parent) {
                this.parents[objectUUID] = {
                    parent,
                    index: parentInfo.index,
                };
            }
        });
    }
}
